import { forwardRef } from 'react';
import Modal from '@/components/common/modal/modal';
import type { ModalAction } from '@/components/common/modal/modal.type';
import CollectionItem from '@/components/user/collection-item/collection-item';
import CollectionMenu from '@/components/user/collection-menu-modal/collection-menu';
import useCollectionMenuContext from '@/components/user/collection-menu-modal/hook';
import { useIsDesktop } from '@/hooks/use-user-platform';

interface Props {
  onClose: () => void;
  contextMenuType?: 'forward' | 'normal';
}

const CollectionMenuModal = forwardRef<ModalAction, Props>(({ onClose, contextMenuType }, ref) => {
  const { selected, position } = useCollectionMenuContext();
  const isDesktop = useIsDesktop();

  if (isDesktop && position) {
    const [posX, posY] = position;

    return (
      <div
        className='absolute z-50'
        style={{ left: `calc(${posX}px - (50vw - 30rem))`, top: `calc(${posY}px - 4rem)` }}>
        <CollectionMenu
          contextMenuType={contextMenuType}
          onClose={onClose}
        />
      </div>
    );
  }

  return (
    <Modal
      ref={ref}
      className='items-start'
      onClose={onClose}
      clickOutsideToClose
      contentClassName='select-none w-fit rounded-none bg-transparent p-0 shadow-none gap-4 items-start flex flex-col'>
      {selected && (
        <CollectionItem
          showContextMenu={false}
          className='z-20'
          collection={selected}
        />
      )}

      <CollectionMenu
        contextMenuType={contextMenuType}
        onClose={onClose}
      />
    </Modal>
  );
});

CollectionMenuModal.displayName = 'CollectionMenuModal';

export default CollectionMenuModal;
